export const brandColor = '#00A064'
export const cvColror = '#FFC847'
export const cvHoverColor = '#FADFA0'
export const brandHoverColor = '#088B5A'
export const discountColor = '#f76262'
